export default class Trigger {
  constructor(trigger = {}) {
    this.key = `${trigger.indicatorId}-${trigger.unitId}-${trigger.system}-${trigger.processId ? trigger.processId : 0}-${trigger.productId ? trigger.productId : 0}-${trigger.equipmentId ? trigger.equipmentId : 0}`
    this.id = trigger.id ? trigger.id : 0
    this.indicatorId = trigger.indicatorId || trigger.indicatorId == 0 ? trigger.indicatorId : -9999
    this.indicatorName = trigger.indicatorName ? trigger.indicatorName : ""
    this.unitId = trigger.unitId ? trigger.unitId : 0
    this.system = trigger.system ? trigger.system : ""
    this.triggerId = trigger.triggerId ? trigger.triggerId : 0
    this.processId = trigger.processId ? trigger.processId : 0
    this.process = trigger.process ? trigger.process : ""
    this.equipmentId = trigger.equipmentId ? trigger.equipmentId : 0
    this.equipment = trigger.equipment ? trigger.equipment : ""
    this.productId = trigger.productId ? trigger.productId : 0
    this.product = trigger.product ? trigger.product : ""
    this.active = trigger.active ? trigger.active : false
    this.configurationJSON = trigger.configurationJSON ? trigger.configurationJSON : ""
    this.target = trigger.target ? trigger.target : 0
    this.operationalRange = trigger.operationalRange ? trigger.operationalRange : 0
    this.criticalRange = trigger.criticalRange ? trigger.criticalRange : 0
    this.reliabilityThreshold = trigger.reliabilityThreshold ? trigger.reliabilityThreshold : 0
    this.reliabilityCritical = trigger.reliabilityCritical ? trigger.reliabilityCritical : 0
    this.triggercode = trigger.triggercode ? trigger.triggercode : ""
  }

  setIndicator(ind) {
    this.indicatorId = ind.id
    this.indicatorName = ind.indicatorName
    this.unitId = ind.productionUnitId
    this.system = ind.system

    this.setRule(ind)
  }

  setRule(ind) {
    let rule = ind.indicatorRule.split(" ")
    this.operatingRange = rule[1]
    this.criticalRange = rule[2]
  }

  setReliability(indConf) {
    if (indConf) {
      this.reliabilityThreshold = indConf.reabilityThreshold
      this.reliabilityCritical = indConf.criticReabilityThreshold
    }
  }

  async setContent(json) {
    let configurationJSON = json

    // Se já existir o conteudo: sobrescreve
    if (this.configurationJSON) {
      configurationJSON = await JSON.parse(this.configurationJSON)
      configurationJSON = { ...configurationJSON, ...json }
    }

    this.configurationJSON = JSON.stringify(configurationJSON)
  }

  clear() {
    this.id = 0
    this.indicatorId = 0
    this.indicatorName = ""
    this.unitId = 0
    this.system = ""
    this.triggerId = 0
    this.processId = 0
    this.process = ""
    this.equipmentId = 0
    this.equipment = ""
    this.productId = 0
    this.product = ""
    this.active = false
    this.configurationJSON = ""
    this.target = 0
    this.operationalRange = 0
    this.criticalRange = 0
    this.reliabilityThreshold = 0
    this.reliabilityCritical = 0
    this.triggercode = ""
  }
}